import React from "react";
import { Link, useHistory } from "react-router-dom";
import Container from "../../components/Container";
import CTAButton from "../../components/CTAButton";
import Datalayer from "../../services/datalayer";
import { useGeneralContext } from "../../context/GeneralContext";
import { useAuthContext } from "../../context/AuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/Button";

import * as S from "./styles";

const Profile = () => {
  let history = useHistory();
  const { user, generalContextLoading } = useGeneralContext();
  const { isLoggedIn } = useAuthContext();
  const { signOut } = useAuthContext();

  const { email: userEmail } = isLoggedIn && user;

  if (generalContextLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Container pageName="Minha conta" type="minimal">
      <S.OverlayContainer>
        <S.BannerTextContainer>
          <S.BannerTitle>7 dias de garantia</S.BannerTitle>
          <S.BannerText className={"banner-title"}>
            A partir de $ R$ 39,90 mensais , você tem acesso ilimitado a mais de
            300 cursos originais.
          </S.BannerText>
        </S.BannerTextContainer>

        <Link to={"/signup"}>
          <CTAButton
            small
            id={"btn-account_explore-assine_agora"}
            name={"btn-account_explore-assine_agora"}
            onClick={() =>
              Datalayer.onClick("explore", "assine-agora", "app-explore")
            }
            text={"ASSINE AGORA"}
          />
        </Link>
      </S.OverlayContainer>

      <S.Wrapper>
        <S.SubTitle dark>{"Informações da conta"}</S.SubTitle>
        <S.UserInfo bottom>
          {!!userEmail ? userEmail : "meuemail@email.com"}
        </S.UserInfo>
        <S.UserInfo bottom>
          {"Dados Pessoais"}
          <S.SmallButton>{<i className="fas fa-lock-alt" />}</S.SmallButton>
        </S.UserInfo>
        <S.UserInfo space>
          {"Senha: ******"}
          {isLoggedIn ? (
            <Button
              size={"small"}
              onClick={() => history.push("/alterar-senha")}
            >
              alterar senha
            </Button>
          ) : (
            <S.SmallButton>
              <i className="fas fa-lock-alt" />
            </S.SmallButton>
          )}
        </S.UserInfo>

        <S.SubTitle dark>{"Minha assinatura"}</S.SubTitle>
        <S.UserInfo bottom>
          {"Plano Anual"}
          <S.SmallButton>{<i className="fas fa-lock-alt" />}</S.SmallButton>
        </S.UserInfo>
        <S.UserInfo space>
          {"Detalhes da assinatura"}
          <S.SmallButton>{<i className="fas fa-lock-alt" />}</S.SmallButton>
        </S.UserInfo>

        <S.SubTitle dark>{"Certificados de conclusão"}</S.SubTitle>
        <S.UserInfo space>
          {"Meus certificados"}
          <S.SmallButton>{<i className="fas fa-lock-alt" />}</S.SmallButton>
        </S.UserInfo>

        <S.SubTitle dark>
          {"Minha lista de cursos para assistir depois"}
        </S.SubTitle>
        <S.UserInfo space>
          {"Minha lista"}
          <S.SmallButton>{<i className="fas fa-lock-alt" />}</S.SmallButton>
        </S.UserInfo>

        <CTAButton
          dark
          outlined
          text="sair da conta"
          onClick={() => {
            signOut();
            window.location = "https://casadosaber.com.br";
          }}
          id={"btn-account_explore-sair_da_conta"}
          name={"btn-account_explore-sair_da_conta"}
        />
      </S.Wrapper>
    </Container>
  );
};

export default Profile;
